import { render, staticRenderFns } from "./EditResourceAvatar.vue?vue&type=template&id=412fa8e0&scoped=true&lang=pug&"
import script from "./EditResourceAvatar.vue?vue&type=script&lang=js&"
export * from "./EditResourceAvatar.vue?vue&type=script&lang=js&"
import style0 from "./EditResourceAvatar.vue?vue&type=style&index=0&id=412fa8e0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412fa8e0",
  null
  
)

export default component.exports